import React from "react";
import { motion } from "framer-motion";
import { Wheat, ChefHat, Leaf, Heart } from "lucide-react";
import { differentials } from "../data/menu";

const iconMap = { Wheat, ChefHat, Leaf, Heart };

const Differentials = () => {
  return (
    <section
      id="diferenciais"
      className="relative py-24 sm:py-32 bg-[var(--sn-bg-deep)] overflow-hidden"
      data-testid="differentials-section"
    >
      <div className="absolute inset-0 sn-grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20 items-center">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[var(--sn-gold)]" />
              <span className="text-[var(--sn-gold)] tracking-[0.3em] text-xs uppercase">
                Nossos Diferenciais
              </span>
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--sn-cream)] leading-tight mb-6"
              data-testid="differentials-headline"
            >
              O que torna a Santo Nhoque{" "}
              <span className="italic gold-text">única.</span>
            </h2>
            <p className="text-[var(--sn-cream-soft)]/80 leading-relaxed font-body">
              Não é industrial. Não é congelado de fábrica. É feito todos os
              dias, na nossa cozinha, com a mesma dedicação de quem cozinha
              para a própria família.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {differentials.map((d, i) => {
              const Icon = iconMap[d.icon] || Wheat;
              return (
                <motion.div
                  key={d.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.08 }}
                  className={`group relative bg-[var(--sn-bg-surface)]/40 hover:bg-[var(--sn-bg-surface)]/80 border border-[var(--sn-border)] hover:border-[var(--sn-gold)] p-7 transition-all duration-500 ${
                    i % 2 === 0 ? "sm:translate-y-4" : ""
                  }`}
                  data-testid={`differential-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-full border border-[var(--sn-gold)] flex items-center justify-center mb-5 group-hover:bg-[var(--sn-gold)]/10 transition-colors">
                    <Icon className="w-5 h-5 text-[var(--sn-gold)]" />
                  </div>
                  <h3 className="font-display text-2xl text-[var(--sn-cream)] mb-2 group-hover:text-[var(--sn-gold)] transition-colors">
                    {d.title}
                  </h3>
                  <p className="text-[var(--sn-cream-soft)]/75 text-sm leading-relaxed">
                    {d.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentials;
